<div class="card border-secondary my-1">
  <div class="card-body ">
    <!-- Renderização do título do card e dos botões -->
    <div *ngIf="item!.title || hasMenu" class="d-flex w-100">
      <div class="flex-fill">
        <h5 *ngIf="!editing && !titleTemplate" class="card-title small">{{item!.title || ""}}</h5>
        <ng-container *ngIf="!editing && titleTemplate" [ngTemplateOutlet]="titleTemplate" [ngTemplateOutletContext]="{card: item, context: kanban?.context, metadata: metadata}"></ng-container>
        <ng-container *ngIf="editing && editTitleTemplate" [ngTemplateOutlet]="editTitleTemplate" [ngTemplateOutletContext]="{card: item, context: kanban?.context, metadata: metadata}"></ng-container>
      </div>
      <div *ngIf="editing" class="btn-group" role="group">
        <button type="button" id="card_edit_button" class="btn btn-outline-primary" (click)="docker?.onCardSaveClick(this)">
          <i class="bi bi-check-circle"></i>
        </button>
        <button type="button" id="card_cancel_button" class="btn btn-outline-danger" (click)="docker?.onCardCancelClick(this)">
          <i class="bi bi-dash-circle"></i>
        </button>
      </div>
      <div *ngIf="!editing && hasMenu" class="btn-group card-buttons" role="group" aria-label="Opções">
        <div *ngFor="let btn of menu" class="btn-group" role="group">
          <button [id]="generatedButtonId(btn)" #itemsButton type="button" [class]="'btn btn-sm ' + (btn.color || 'btn-outline-primary')" [class.dropdown-toggle]="hasButtonItems(btn)" [attr.data-bs-toggle]="hasButtonItems(btn) ? 'dropdown' : undefined" aria-expanded="false" (click)="onButtonClick(btn)">
            <i *ngIf="btn.icon?.length" [class]="btn.icon" data-bs-toggle="tooltip" data-bs-placement="top" [attr.title]="btn.hint || btn.label || ''"></i>
          </button>
          <ul *ngIf="hasButtonItems(btn)" class="dropdown-menu dropdown-menu-end" [attr.aria-labelledby]="generatedButtonId(btn)">
            <li *ngFor="let option of getButtonItems(itemsButton, btn)">
              <hr *ngIf="option.divider" class="dropdown-divider">
              <a *ngIf="!option.divider" class="dropdown-item" [id]="generatedButtonId(option, '_option')" role="button" (click)="onButtonClick(option)"><i *ngIf="option.icon?.length" [class]="option.icon"></i> {{option.label || ""}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Renderização do corpo do card -->
    <div *ngIf="!editing">
      <div class="flex-fill mt-2">
        <h6 *ngIf="item!.subTitle" class="card-subtitle mb-2 text-muted small "><text-html *ngIf="item!.subTitle" [html]="item!.subTitle" [analiser]="editorService.bindProfileClick.bind(editorService)"></text-html></h6><!--{{item!.subTitle}}</h6>-->
        <text-html *ngIf="item!.text" [html]="item!.text" [analiser]="editorService.bindProfileClick.bind(editorService)"></text-html>
      </div>
      <ng-container *ngIf="template" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{card: item, context: kanban?.context, metadata: metadata}"></ng-container>
    </div>
    <ng-container *ngIf="editing && editTemplate" [ngTemplateOutlet]="editTemplate!" [ngTemplateOutletContext]="{card: item, context: kanban?.context, metadata: metadata}"></ng-container>
  </div>
</div>